import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import "@/styles/account.css";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogle(role = "client") {
  try { sessionStorage.setItem("99t_auth_role", role); } catch (e) {}
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleButton({ label = "Continue with Google", role = "client" }) {
  return (
    <button type="button" className="google-btn" data-testid="google-signin-btn" onClick={() => startGoogle(role)}>
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.6l-6.5 5C9.6 39.6 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.1-2.1 3.9-3.9 5.2l6.3 5.3C41.6 35.7 44 30.3 44 24c0-1.3-.1-2.3-.4-3.5z"/>
      </svg>
      {label}
    </button>
  );
}

export function AccountShell({ title, subtitle, children }) {
  return (
    <div className="auth-wrap">
      <div className="auth-card" data-testid="auth-card">
        <a className="auth-logo" href="/"><i /> 99tests</a>
        <h1 className="auth-title">{title}</h1>
        {subtitle && <p className="auth-sub">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}

export function AccountMenu() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  if (loading) return null;
  if (!user) return (<a href="/login" data-testid="nav-signin">Sign in</a>);
  return (
    <>
      <a href={user.role === "tester" ? "/tester" : "/dashboard"} data-testid="nav-dashboard">Dashboard</a>
      <a href="#" data-testid="nav-signout" onClick={async (e) => { e.preventDefault(); await logout(); navigate("/"); }}>Sign out</a>
    </>
  );
}

export function DashHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="site-header"><div className="wrap">
      <a className="logo" href="/"><i></i>99tests</a>
      <nav>
        <a href="/pricing" data-testid="dash-start-job">Start a job</a>
        {user?.role === "tester"
          ? <a href="/tester" data-testid="dash-tester-link">Tester dashboard</a>
          : <a href="/dashboard" data-testid="dash-buyer-link">Dashboard</a>}
        <a href="#" data-testid="dash-signout" onClick={async (e) => { e.preventDefault(); await logout(); navigate("/"); }}>Sign out</a>
      </nav>
    </div></header>
  );
}
